import React from 'react';
import WorkItemTrackingGrid from './WorkItemTrackingGrid';

export default function WorkItemTracking() {
  return <WorkItemTrackingGrid />;
}
